import { Text } from '@mantine/core';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { AuditLogType } from '@portals/types';

interface CreateUserProps {
  auditLog: AuditLogType;
}

export const CreateUser: FC<CreateUserProps> = ({ auditLog }) => (
  <Text size="sm">
    Created {auditLog?.params[0]?.model}:{' '}
    <Text<typeof Link>
      size="sm"
      component={Link}
      to="/settings/users_and_groups/users"
      color="blue"
      underline
    >
      {auditLog?.params[0]?.display_name}
    </Text>
  </Text>
);
